(ns dashboard.views.settings.rooms
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.subs.event-organizer :as event-organizer-subs]
   [dashboard.utils :refer [listen]]
   [dashboard.events.rooms :as room-events]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.inputs :refer [input textarea]]
   [dashboard.components.table :refer [table]]
   [dashboard.components.radiogroup :refer [color-circle color-group]]))

(defn- room-drawer-content [{:keys [state dialog-state]}]
  [:div.relative.mt-6.flex-1

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :room/name)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "name"
       :name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:room :name])
       :on-change #(swap! state assoc-in [:room :name] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :room/nameJp)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "name"
       :name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:room :nameJp])
       :on-change #(swap! state assoc-in [:room :nameJp] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :room/color)]]
    [:div.sm:col-span-3.flex.space-x-2
     [color-group
      {:class "flex"
       :selected (get-in @state [:room :color])
       :on-change #(swap! state assoc-in [:room :color] %)
       :size 4
       :colors (listen ::subs/colors)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :room/type)]]
    [:div.sm:col-span-3
     [input
      {:name "type"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:room :type])
       :on-change #(swap! state assoc-in [:room :type] %)}]]]

   [:div.border-t.border-gray-200.py-2
    [:div.mt-1
     [textarea
      {:rows 4
       :name "description"
       :id "description"
       :label (tr :room/description)
       :default-value (get-in @state [:room :description])
       :on-change #(swap! state assoc-in [:room :description] %)}]]]

   [:div.mt-3
    [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
     (tr :room/coordinates)]
    (doall
     (for [i (range 4)]
       ^{:key (str "coordinates-" i)}
       [:div.mt-2.flex.space-x-2
        [input
         {:name (str "x-" i)
          :class "w-20"
          :type "number"
          :disabled? (= (:action @state) :view)
          :value (get-in @state [:room :geometry :coordinates 0 i 0])
          :on-change #(do
                        (swap! state assoc-in [:room :geometry :coordinates 0 i 0] (int %))
                        (when (= i 0)
                          (do
                            (swap! state assoc-in [:room :geometry :coordinates 0 3 0] (int %))
                            (swap! state assoc-in [:room :geometry :coordinates 0 4 0] (int %))))
                        (when (= i 1)
                          (swap! state assoc-in [:room :geometry :coordinates 0 2 0] (int %))))}]
        [input
         {:name (str "x-" i)
          :class "w-20"
          :type "number"
          :disabled? (= (:action @state) :view)
          :value (get-in @state [:room :geometry :coordinates 0 i 1])
          :on-change #(do
                        (swap! state assoc-in [:room :geometry :coordinates 0 i 1] (int %))
                        (when (= i 0)
                          (do
                            (swap! state assoc-in [:room :geometry :coordinates 0 1 1] (int %))
                            (swap! state assoc-in [:room :geometry :coordinates 0 4 1] (int %))))
                        (when (= i 2)
                          (do
                            (swap! state assoc-in [:room :geometry :coordinates 0 3 1] (int %)))))}]]))]

   [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-4.sm:space-y-0.mt-4
    [button
     {:on-click #(do
                   (re-frame/dispatch
                    (case (:action @state)
                      :add [::room-events/create-room {:room (:room @state)}]
                      :delete [::room-events/delete-room {:room (:room @state)}]
                      :edit [::room-events/update-room {:room (:room @state)}]
                      ""))
                   (reset! state {:is-open? false
                                  :room nil
                                  :action nil}))}
     (case (:action @state)
       :add (tr :action/create)
       :delete (tr :action/delete)
       :edit (tr :action/save)
       "")]]])

(defn content []
  (let [drawer-state (reagent/atom {:is-open? false
                                    :room nil
                                    :action :edit})]
    (fn []
      (let [default-room {:name ""
                          :nameJp ""
                          :color "red"
                          :type ""
                          :description ""
                          :geometry {:type "Polygon"
                                     :coordinates [[[0 0]
                                                    [0 0]
                                                    [0 0]
                                                    [0 0]
                                                    [0 0]]]}
                          :eventId (listen ::event-organizer-subs/selected-event-id)
                          :organizationId (:id (listen ::subs/organization))}]
        [:div
         [drawer
          {:state drawer-state
           :title (case (:action @drawer-state)
                    :add (tr :action/add-fn (tr :room))
                    :delete (tr :action/delete-fn (tr :room))
                    :edit (tr :action/edit-fn (tr :room))
                    "")
           :content [room-drawer-content
                     {:state drawer-state}]}]
         [:div.px-4.pt-6
          [:div.sm:flex.sm:items-center
           [:div.sm:flex-auto]
           [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
            [button
             {:on-click #(reset! drawer-state {:is-open? true
                                               :room default-room
                                               :action :add})}
             (tr :action/add-fn (tr :room))]]]]
         [:div.divide-y.divide-gray-200
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :room/color)
                        :key :color
                        :class "w-10"
                        :render-cell (fn [color]
                                       [:div.flex.justify-center
                                        [color-circle
                                         {:color color
                                          :size 6}]])}
                       {:title (tr :room/name)
                        :key :name
                        :render-cell (fn [name row]
                                       [:div.flex.flex-col
                                        [:span.font-semibold
                                         name]
                                        [:span.text-gray-500
                                         (:nameJp row)]])}
                       {:title (tr :room/type)
                        :key :type
                        :render-cell (fn [type]
                                       [:span
                                        type])}
                       {:title (tr :room/description)
                        :key :description
                        :render-cell (fn [desc]
                                       [:span
                                        desc])}]
             :rows (->> (listen ::event-organizer-subs/rooms)
                        (sort-by :name))
             :group-by-fn :type
             :actions [{:name :edit
                        :text (tr :action/edit)
                        :on-click #(reset! drawer-state {:is-open? true
                                                         :room %
                                                         :action :edit})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click #(reset! drawer-state {:is-open? true
                                                         :room %
                                                         :action :delete})}]}]]
          [:div.pt-6.divide-y.divide-gray-200
           [:div.py-4.px-4.flex.justify-end.sm:px-6
            [button
             {:type "submit"}
             (tr :action/save)]]]]]))))
